export default __webpack_public_path__ + "static/media/fractal2.0.046eedfd.mp4";